module.exports = __webpack_public_path__ + "static/landing-bg_lowres-fb602c134a8d9ca9a21295c53bf271a5.jpg";